import { FeatureAccessValue, usePlanFeatureGate } from './use-plan-feature-gate';
import { Features } from '../constants/features';
import { useIsSellerFeatureEnabled } from '../hooks/use-is-seller-feature-enabled';

/** @typedef {import('../prop-types/intl-types').MessageDescriptor} MessageDescriptor */

/**
 * Automated Rate Shopper is the more advanced RateShopper feature
 * that allows users to create and customize their own collection of services.
 * The useFreemiumRateShopperFeatureGate controls the more basic RateShopper feature.
 *
 * By default it is not available
 * @returns {{ isFeatureEnabled: boolean, disabledMessage?: MessageDescriptor}}
 */
export const useAutomatedRateShopperFeatureGate = () => {
  // This was already a seller feature but to keep things consistent we pass that evaluation through to our usePlanFeatureGate hook
  const sellerAlreadyHasFeature = useIsSellerFeatureEnabled(Features.ShippingStrategies);
  const defaultSellerFeatureAccessValue = sellerAlreadyHasFeature ? FeatureAccessValue.Enabled : FeatureAccessValue.Disabled;

  return usePlanFeatureGate(Features.ShippingStrategies, defaultSellerFeatureAccessValue);
};
